import { render } from "./Tarefa.vue?vue&type=template&id=df77f142&scoped=true&ts=true"
import script from "./Tarefa.vue?vue&type=script&lang=ts"
export * from "./Tarefa.vue?vue&type=script&lang=ts"

import "./Tarefa.vue?vue&type=style&index=0&id=df77f142&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df77f142"]])

export default __exports__